var map = {
	"./avatar1.svg": 9469,
	"./avatar2.svg": 7969,
	"./avatar3.svg": 5103,
	"./facebook.svg": 1723,
	"./instagram.svg": 4793,
	"./twitter.svg": 3060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9559;